export default "__VITE_ASSET__DWPRI$_M__"